<template>
  <div>
    <div class="tw-mb-2 tw-text-sf-slate">{{ groupName }}</div>

    <div class="tw-flex tw-flex-wrap tw-gap-3">
      <AddFilterItem
        v-for="filterType in visibleFilterTypes"
        :key="filterType"
        :filter-definition="filterDefinitionsByType[filterType]"
        :lite-mode="liteMode"
        @edit-filter="editFilter"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { filterDefinitions } from '@app/insights/filter-definitions'
import type { FilterDefinition, FilterGroup } from '@app/insights/types'
import { useFilterVisibility } from '@app/insights/composables/use-filter-visibility'
import AddFilterItem from './add-filter-item.vue'
import I18n from 'i18n-js'

defineOptions({ name: 'AddFilterGroup' })

const props =
  defineProps<{
    group: FilterGroup
    liteMode?: boolean
  }>()

const emit =
  defineEmits<{
    editFilter: []
  }>()

// Composables
const { isFilterVisible } = useFilterVisibility()

// Derived constants
const filterDefinitionsByType = filterDefinitions.reduce(
  (acc, filterDefinition) => {
    acc[filterDefinition.type] = filterDefinition
    return acc
  },
  {} as Record<string, FilterDefinition>
)

// Computed
const groupName = computed(() =>
  I18n.t(`companies_overview.filter_groups.${props.group.nameKey}.name`)
)

const visibleFilterTypes = computed(() =>
  props.group.filterTypes.filter((filterType) => {
    const definition = filterDefinitionsByType[filterType]
    if (!definition) return false

    return isFilterVisible(definition)
  })
)

// Handlers
function editFilter() {
  emit('editFilter')
}
</script>
